module.exports = __webpack_public_path__ + "img/mailbox.ab3878f2.png";